import BikeCard from "./BikeCard"
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useEffect, useState } from "react";

import "swiper/css/pagination";
import "swiper/css";
import { getBikes } from "../getBikes"

const Bikes = ({ text, lang }) => {
    const [bikes, setBikes] = useState([]);

    useEffect(() => {
        getBikes().then(setBikes);
    }, []);

    return (
        <div className="block_2" id="fleet">
            <h2>{text["title_2"][lang]}</h2>
            <h6>{text["subtitle_2"][lang]}</h6>

            <Swiper
                modules={[Pagination]}
                pagination={{ clickable: true }}
                spaceBetween={20}
                slidesPerView={1}
            >
                {bikes.map(bike => (
                    <SwiperSlide key={bike._id}>
                        <BikeCard
                            id={bike._id}
                            img={bike.imageUrl}
                            name={bike.name}
                            kms={bike.kms}
                            type={bike.type}
                            mountain={bike.category}
                            h_3={bike.prices?.h3}
                            h_5={bike.prices?.h5}
                            one_day={bike.prices?.oneDay}
                            two_days={bike.prices?.twoDays}
                            three_days={bike.prices?.threeDays}
                            five_days={bike.prices?.fiveDays}
                            text={text} lang={lang}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default Bikes;